/* ── APO Fabric Drawer ─────────────────────────────────────────── */

function setupApoFabricDrawer(apoContainer) {
  const drawerBody = document.getElementById('ApoFabricDrawerBody');
  const trigger = document.getElementById('ApoFabricTrigger');
  if (!drawerBody || !trigger) return;

  drawerBody.appendChild(apoContainer);
  trigger.removeAttribute('hidden');

  updateApoTriggerLabel();

  // Update label on any APO interaction; close drawer when colour swatch selected
  apoContainer.addEventListener('click', (event) => {
    setTimeout(() => {
      updateApoTriggerLabel();

      // Close drawer when a swatch colour value is clicked (full selection done)
      const swatchValue = event.target.closest(
        '.mw-option--type-swatch:not(.mw-hidden) .mw-option__value'
      );
      if (swatchValue) {
        const drawer = document.getElementById('ApoFabricDrawer');
        if (drawer) drawer.removeAttribute('open');
      }
    }, 150);
  });
}

const APO_FABRIC_ICON_SVG = `<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.63585 19.5659L7.54932 21.7154L9.63585 23.8651L7.54932 26.0149L9.5724 28.0993L7.89509 29.8277L9.98162 31.9772L11.6589 30.2491L13.682 32.3334L15.7685 30.1837L17.8551 32.3334L19.9416 30.1837L22.0279 32.3334L24.1144 30.1837L26.2009 32.3334L28.224 30.2491L29.8684 31.9432L31.9549 29.7938L30.3105 28.0993L32.3336 26.0149L30.2471 23.8651L32.3336 21.7154L30.2471 19.5659L32.3336 17.4162L30.2471 15.2664L32.3336 13.1166L30.3105 11.0322L31.9879 9.3041L29.9016 7.15434L28.224 8.88249L26.2009 6.7981L24.1144 8.94786L22.0279 6.7981L19.9416 8.94786L17.8551 6.7981L15.7685 8.94786L13.682 6.7981L11.6589 8.88249L10.0146 7.18831L7.92806 9.33807L9.5724 11.0322L7.54932 13.1166L9.63585 15.2664L7.54932 17.4162L9.63585 19.5659Z" fill="white" stroke="#96531F" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.42003 13.1012L0.333496 15.2506L2.42003 17.4004L0.333496 19.5502L2.35658 21.6345L0.679266 23.363L2.7658 25.5124L4.44311 23.7843L6.4662 25.8687L8.55273 23.7189L10.6393 25.8687L12.7258 23.7189L14.812 25.8687L16.8986 23.7189L18.9851 25.8687L21.0082 23.7843L22.6525 25.4785L24.7391 23.329L23.0947 21.6345L25.1178 19.5502L23.0313 17.4004L25.1178 15.2506L23.0313 13.1012L25.1178 10.9514L23.0313 8.80164L25.1178 6.65188L23.0947 4.56749L24.772 2.83935L22.6858 0.689591L21.0082 2.41773L18.9851 0.333344L16.8986 2.4831L14.812 0.333344L12.7258 2.4831L10.6393 0.333344L8.55273 2.4831L6.4662 0.333344L4.44311 2.41773L2.79877 0.72356L0.712236 2.87332L2.35658 4.56749L0.333496 6.65188L2.42003 8.80164L0.333496 10.9514L2.42003 13.1012Z" fill="white" stroke="#96531F" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

function updateApoTriggerLabel() {
  const valueEl = document.getElementById('ApoFabricValue');
  const iconEl = document.querySelector('#ApoFabricTrigger .product-option-trigger__icon');
  if (!valueEl) return;

  const parts = [];
  let swatchImgSrc = null;

  // Fabric type — button picker uses mw-option__value--selected
  const selectedType = document.querySelector(
    '.mw-apo-container #o_1226859 .mw-option__value--selected label, ' +
    '.mw-apo-container #o_1226859 .mw-option__value--selected .mw-label'
  );
  if (selectedType) parts.push(selectedType.textContent.trim());

  // Colour — APO writes the selected name into .mw-accumulated-title
  const visibleColourOption = document.querySelector(
    '.mw-apo-container .mw-option--type-swatch:not(.mw-hidden)'
  );
  if (visibleColourOption) {
    const colourName = visibleColourOption.querySelector('.mw-accumulated-title');
    if (colourName && colourName.textContent.trim()) {
      parts.push(colourName.textContent.trim());

      // Grab the swatch image from the selected colour value
      const selectedSwatch = visibleColourOption.querySelector('.mw-option__value--selected');
      const swatchImg = selectedSwatch?.querySelector('.mw-option__swatch-media img');
      if (swatchImg) swatchImgSrc = swatchImg.src;
    }
  }

  valueEl.textContent = parts.length ? parts.join(' / ') : 'Select a fabric';

  if (parts.length) {
    document.getElementById('ApoFabricTrigger')?.classList.remove('product-option-trigger--error');
  }

  // Swap the icon to the swatch thumbnail once a colour is chosen, reset when not
  if (iconEl) {
    if (swatchImgSrc) {
      iconEl.innerHTML = `<img src="${swatchImgSrc}" alt="" class="product-option-trigger__swatch-preview">`;
    } else {
      iconEl.innerHTML = APO_FABRIC_ICON_SVG;
    }
  }
}

// Use MutationObserver to catch APO injection (it runs after page load)
(function watchForApo() {
  const apoContainer = document.querySelector('.mw-apo-container');
  if (apoContainer) {
    setupApoFabricDrawer(apoContainer);
    return;
  }
  const observer = new MutationObserver(() => {
    const apo = document.querySelector('.mw-apo-container');
    if (apo) {
      observer.disconnect();
      setupApoFabricDrawer(apo);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

/* ── Native variant drawer options ─────────────────────────────── */

document.addEventListener('click', (event) => {
  const optionBtn = event.target.closest('.product-option-drawer__option[data-option-value]');
  if (!optionBtn) return;

  const { optionName, optionValue, optionIndex } = optionBtn.dataset;
  const drawer = optionBtn.closest('drawer-component');

  // The hidden variant-selects renders one fieldset per option, in order.
  // optionIndex is 1-based (matching option.position), so fieldsets[optionIndex - 1].
  const variantSelects = document.querySelector('variant-selects');
  if (variantSelects) {
    const fieldsets = variantSelects.querySelectorAll('fieldset');
    const fieldset = fieldsets[Number(optionIndex) - 1];

    if (fieldset) {
      const hiddenInput = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
        (input) => input.value === optionValue
      );
      if (hiddenInput && !hiddenInput.checked) {
        hiddenInput.checked = true;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // Update visual state within this drawer
  drawer.querySelectorAll('.product-option-drawer__option').forEach((btn) => {
    const selected = btn.dataset.optionValue === optionValue;
    btn.classList.toggle('product-option-drawer__option--selected', selected);
    btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });

  // Update the trigger row's displayed value and icon
  const trigger = document.querySelector(`[aria-controls="${drawer.id}"]`);
  const triggerValue = trigger?.querySelector(`[data-selected-option-value="${optionName}"]`);
  if (triggerValue) triggerValue.textContent = optionValue;

  const optionIcon = optionBtn.dataset.optionIcon;
  const triggerIcon = trigger?.querySelector('.product-option-trigger__icon');
  if (triggerIcon && optionIcon) {
    triggerIcon.innerHTML = `<img src="${optionIcon}" alt="" class="product-option-trigger__swatch-preview">`;
  }

  // Close the drawer
  drawer.removeAttribute('open');
});

/* ── "Dimensions" deep-link ─────────────────────────────────────── */
// Size-info RTE links "click here" to #dimensions. Open the matching product
// tab and scroll to it, closing the drawer first so we don't scroll behind it.
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href*="#dimensions" i]');
  if (!link) return;

  const href = (link.getAttribute('href') || '').trim();
  const samePage = href.startsWith('#') || link.pathname === window.location.pathname;
  if (!samePage || (link.hash || '').toLowerCase() !== '#dimensions') return;

  // Tabs can render in the main blocks column or under the media gallery;
  // both containers carry the .accordion-parent class.
  const tabs = document.querySelectorAll('.accordion-parent details[is="accordion-group"]');
  let target = null;
  tabs.forEach((tab) => {
    const heading = tab.querySelector('summary h2, summary h3, summary .inline-richtext');
    if (!target && heading && heading.textContent.trim().toLowerCase() === 'dimensions') {
      target = tab;
    }
  });
  if (!target) return;

  event.preventDefault();

  // Header is <header is="sticky-header"> (a customized built-in, not a <sticky-header> tag).
  // Only a sticky header overlaps content; a basic-header scrolls away, so offset stays 0.
  const header =
    document.querySelector('.header-section header[is="sticky-header"]') ||
    document.querySelector('header[is="sticky-header"]');
  const headerOffset = header ? header.offsetHeight : 0;

  const revealTab = () => {
    if (!target.open) target.open = true; // opening also collapses sibling tabs
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
    window.scrollTo({ top, behavior: 'smooth' });
    target.querySelector('summary')?.focus({ preventScroll: true });
  };

  const drawer = link.closest('drawer-component');
  if (drawer && typeof drawer.hide === 'function') {
    // Null the stored trigger so the drawer's focus-restore can't scroll us back
    // to the top on close, and wait for hide() to release the body scroll lock.
    drawer.activeElement = null;
    Promise.resolve(drawer.hide()).then(() => requestAnimationFrame(revealTab));
  } else {
    revealTab();
  }
});

/* ── APO add-to-cart validation ─────────────────────────────────── */
// Capture phase runs before APO's own button listeners (which may stopPropagation).
document.addEventListener('click', (event) => {
  if (!event.target.closest('button[name="add"]')) return;

  const apoTrigger = document.getElementById('ApoFabricTrigger');
  if (!apoTrigger || apoTrigger.hidden) return;

  const valueEl = document.getElementById('ApoFabricValue');
  if (!valueEl || valueEl.textContent.trim() !== 'Select a fabric') return;

  apoTrigger.classList.add('product-option-trigger--error');
  apoTrigger.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

  const drawer = document.getElementById('ApoFabricDrawer');
  if (drawer && !drawer.hasAttribute('open')) {
    apoTrigger.click();
  }
}, true);
